<div class="page-content" *ngIf="!timerService.isForwarding">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page-title" translate>{{'CCB_main.page_title'}}</h1>
     
     <div [innerHTML]="'CCB_main.ccbText'|translate"></div>
     
      
     <div class="ccb-out-div">
      <div class="ccb-in-div" translate='CCB_main.statBox'></div> 
    </div>

     <accordion label="CCB_main.accWhy" outer-class="display-margin">
           <div translate='CCB_main.expWhy_1' class="page-title"></div>
           <div translate='CCB_main.expWhy_2' class="page-title"></div>
            <ul style="list-style: none;">
                  <li class="dash"><a-link link-url="CCB_main.ccbLinkURL" 
                        alt-text="CCB_main.ccbLink_alt" 
                        label='CCB_main.ccbLink'></a-link></li>
                  <li class="dash"><a-link link-url="CCB_main.ocbLinkURL" 
                        alt-text="CCB_main.ocbLink_alt" 
                        label='CCB_main.ocbLink'></a-link></li>
                  <li class="dash"><a-link link-url="CCB_main.creditLinkURL" 
                        alt-text="CCB_main.creditLink_alt" 
                        label='CCB_main.creditLink'></a-link></li>
            </ul>
     </accordion>
     
     <p [innerHTML]="'CCB_main.monthlyText'|translate : childNameParam"></p>
     
     <accordion label="CCB_main.accEligInfo" outer-class="display-margin">
           <div translate='CCB_main.expEligInfo1' class="page-title">  
           <a-link link-url="CCB_main.primaryLinkURL" 
                        alt-text="CCB_main.primaryLink_alt" 
                        label='CCB_main.primaryLink'></a-link>
           <span [innerHTML]="'CCB_main.expEligInfo2_1'|translate"></span>
           </div>
           <div translate='CCB_main.expEligInfo2_2' class="page-title">
           <a-link link-url="CCB_main.benefitLinkURL" 
                        alt-text="CCB_main.benefitLinkALT"
                        label='CCB_main.benefitLink'></a-link>
           <span translate='CCB_main.expEligInfo3'></span>
            </div>    
     </accordion>
     
     <div class="padding-div">
     <accordion label="CCB_main.accPrimInfo" outer-class="display-margin">
           <div translate='CCB_main.expPrimInfo'></div>                 
     </accordion>
      </div>
      <div id="primaryCaregiver">
      <ng-radio [item-list]="data.certifyingParents"   [ng-disable]="CCB.isLocked" id="primaryCaregiverRadio"
               [(ng-model)] ="data.CCB.primaryCaregiver" 
               [(ng-error)]="error_PrimEmpty" vertical>
               <h2 html='CCB_main.whichParent' class="h2-margin"></h2>
      </ng-radio>
      </div>
     <fieldset>
      <legend>
      <h2 id="sin" html='CCB_main.whatSIN' class="h2-margin-sin"></h2>
      </legend>
     <ng-input space="0.5" type="tel" id="sinInput"
           [(ng-model)]="data.CCB.SSN1"   [ng-disable]="CCB.isLocked"
           [(ng-clear)]="error_SSN" 
           alt-text="CCB_main.sin_alt_1"
           size="3" max="3">
      <span translate='CCB_main.sin_alt_1' class="sr-only"></span>
      </ng-input>
      
     <span style="margin-right:0.3em">-</span>
     <ng-input space="0.5" type="tel" 
           [(ng-model)]="data.CCB.SSN2"     [ng-disable]="CCB.isLocked"
           [(ng-clear)]="error_SSN" 
           alt-text="CCB_main.sin_alt_2"
           size="3" max="3">
      <span translate='CCB_main.sin_alt_2' class="sr-only"></span>
      </ng-input>
 
     <span style="margin-right:0.3em">-</span>
     <ng-input space="0.5" type="tel" 
           [(ng-model)]="data.CCB.SSN3"    [ng-disable]="CCB.isLocked"
           [(ng-clear)]="error_SSN" 
           alt-text="CCB_main.sin_alt_3"
           size="3" max="3">
      <span translate='CCB_main.sin_alt_3' class="sr-only"></span>
      </ng-input>
      </fieldset>
      <accordion label="CCB_main.accNeeded" outer-class="display-margin">
            <div translate='CCB_main.expNeeded'>
            <a-link link-url="CCB_main.benefitLinkURL"
                  alt-text="CCB_main.benefitLinkALT" 
                  label='CCB_main.benefitLink'></a-link><span>.</span>
            </div>                 
      </accordion>
     <errors [error]="error_SSN"></errors>
     
     <h2 id="notice" html='CCB_main.notice' style="margin-top: 0.8em;"></h2>
     
     <ng-checkbox [(ng-model)]="data.CCB.chk_consent" id="noticeCheckbox"
                  [(ng-error)]="error_Notice"
                  (click)="showNotice($event);"
                  [title]="'CCB_main.cbNotice_alt' | translate">
           <span translate='CCB_main.cbNotice_1'></span>    
           <a-link link-url="noticeLinkURL" 
                        alt-text="CCB_main.noticeLink_alt" 
                        label='CCB_main.noticeLink'
                        (click)="showNotice($event);"></a-link>
           <span translate='CCB_main.cbNotice_2'></span>
     </ng-checkbox>
    
     <light-box input-class="white-box" outer-style="font-size:0.88em; margin-top:1em">
      <div style="margin-left: 0.9em; margin-right: 0.9em; padding-top: 0.4em;">
            <information outer-class="full">
                  <div class="info-title"> 
                       <strong><span translate='CCB_main.pleaseSelect'></span></strong>
                  </div>
            </information>
      </div>  
            <h3 translate='CCB_main.noticeLB'
                    class='header-lightbox'>
            </h3> 
            
            <div class="margin1">
                  <span translate='CCB_main.explainLB_1'></span>    
                  <a-link link-url="CCB_main.primaryLinkURL" 
                              alt-text="CCB_main.primaryLink_alt" 
                              label='CCB_main.primaryLink'></a-link>
                  <span [innerHTML]="'CCB_main.explainLB_2'|translate"></span> 
                  <a-link link-url="CCB_main.cra_info_source_url"
                          alt-text="CCB_main.cra_info_alt" 
                          label='CCB_main.cra_info_source'></a-link><span>.</span>
            </div>
           
            <div style="margin: 1em 1em 1.8em 1em" style="float:right; cursor:pointer">
                  <a tabindex="0" role="button" (click)="notAgreeClose()" (keypress)="keyPress($event)"
                     style="margin-right:1em" translate='SIN_main.lightbox.close'>
                  </a>
            </div>
                       
            <div class="btn-div" style="margin-top: 3em;">   
                  
                  <button class="btn-next-notice" (click)="agreeClose()" 
                        alt-text="CCB_main.agree_alt" translate>{{'CCB_main.agree'}}</button> 
                  
            </div>  
                              
      </light-box>

        <div class="btn-div">
            <div class="button-top">
                  <button [ngClass]="data.subject.language=='fr'?'btn-next3':'btn-next2'"  
                          title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>{{Button.Next}}</button></div>
            <div class="button-bottom">
                   <button [ngClass]="data.subject.language=='fr'?'btn-cancel3':'btn-cancel2'"  
                           title="{{'CCB_main.noApply_alt'|translate}}" (click)="dontApply()" translate>{{'CCB_main.noApply'}}</button>
            </div>
      </div>
</div>
